<template>
  <div :class="`mapFilters ${expandFilter ? 'isOpen' : 'isClose'}`">
    <div class="mapFilters__wrapper">
      <v-tabs fixed-tabs>
        <v-tab>
          <v-icon left small> mdi-filter-outline </v-icon>
          <strong>{{ $t('dashboard.tabFilter.menu.filter') }}</strong>
        </v-tab>
        <v-tab>
          <v-icon left small> mdi-table </v-icon>
          <strong>{{ $t('dashboard.tabFilter.menu.result') }}</strong>
        </v-tab>
        <v-tab-item>
          <Filters
            :isLoading="loading"
            :filterOptions="filterOptions"
            :selectedPeriod="selectedPeriod"
            :selectedCitys="selectedCitys"
            :selectedTypes="selectedTypes"
            :selectedClients="selectedClients"
            :selectedHosts="selectedHosts"
            :isFindHostMode="isFindHostMode"
            :selectedCountry="selectedCountry"
            :clear="clear"
          />
        </v-tab-item>
        <v-tab-item>
          <v-card flat>
            <v-data-table
              item-key="id"
              hide-default-footer
              disable-pagination
              show-expand
              mobile-breakpoint="599"
              :loading="loading"
              :headers="tableHeaders"
              :items="tableItems"
              :single-expand="singleExpand"
              :expanded.sync="appointmentDetails"
              :no-data-text="$t('appointment.table.noData')"
              :loading-text="$t('appointment.table.loading')"
              @item-expanded="showCardTable"
              @click:row="showPinTable"
            >
              <template v-slot:expanded-item="{ headers }">
                <td class="mapFilters__rowContent" :colspan="headers.length">
                  <!-- details -->
                  <AppointmentDetails
                    :loading="loadingDetails"
                    :appointment="appointmentID"
                  />
                  <!-- /details -->
                </td>
              </template>
            </v-data-table>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </div>

    <!-- desktop -->
    <v-btn
      v-if="!$vuetify.breakpoint.xsOnly"
      @click="expandFilter = !expandFilter"
      class="mapFilters__expandButton"
      color="primary"
      elevation="0"
      small
      dark
    >
      <v-badge
        v-if="tableItems.length"
        offset-y="5"
        offset-x="5"
        color="pink"
        overlap
        left
      >
        <template v-slot:badge>
          <v-progress-circular
            v-if="loading"
            indeterminate
            class="mb-1"
            width="1"
            size="9"
          />
          <span v-if="!loading">{{ tableItems.length }}</span>
        </template>
      </v-badge>
      <v-icon small v-if="expandFilter"> mdi-arrow-left </v-icon>
      <v-icon small v-else> mdi-arrow-right </v-icon>
    </v-btn>

    <!-- mobile -->
    <v-btn
      v-else
      @click="expandFilter = !expandFilter"
      :class="`mapFilters__expandButtonMobile ${expandFilter && 'primary'}`"
      color="white"
    >
      <v-icon :class="`${expandFilter && 'white--text'}`"> mdi-filter </v-icon>
    </v-btn>
  </div>
</template>

<script>
import { catalogDate } from '../../util/catalog'
import reloadRules from '../../util/reload/colorRules'
import MarkerClusterer from '@googlemaps/markerclustererplus'
import moment from 'moment'
import iconSvg from '../../util/iconsSVG/Iconsvg'
import iconSvgCluster from '../../util/iconsSVG/IconCluster'
import { appointmentTableHeaders } from './shared/tableHeaders'

import AppointmentDetails from './shared/AppointmentDetails'
import Filters from './filters/Filters'

import { mapPinContent, mapPinContentLoading } from './mapContent'

const api = require('../../services/dashboard/dashboardService')
const { reloadInfoPin } = require('../../util/reload/checkAppointmentsReload')

export default {
  name: 'MapFilters',

  components: {
    AppointmentDetails,
    Filters,
  },

  data() {
    return {
      expandFilter: false,
      // filtro
      dates: [],
      menu: false,
      filterOptions: {
        staus: [],
        hosts: [],
        types: [],
        citys: [],
        clients: [],
        startDate: '',
        endDate: '',
      },
      isFindHostMode: false,
      // card
      appointmentDetails: [],
      appointmentID: null,
      loadingDetails: true,
      // table
      singleExpand: true,
      tableHeaders: appointmentTableHeaders,
      appointments: [],
      token: null,
      period: 0,
      _interval: null,
      search: null,
    }
  },

  computed: {
    selectedPeriod: {
      get() {
        return this.$store.state.dashboard.selectedPeriod
      },
      set(value) {
        this.period = value

        !value
          ? this.$store.commit('dashboard/setSelectedPeriod', this.period)
          : this.$store.commit('dashboard/setSelectedPeriod', value)
      },
    },
    omsmarkes: {
      get() {
        return this.$store.state.dashboard.omsmarkes
      },
      set(valor) {
        this.$store.commit('dashboard/setOmsmarkes', valor)
      },
    },
    google: {
      get() {
        return this.$store.state.dashboard.google
      },
      set(valor) {
        this.$store.commit('dashboard/setGoogle', valor)
      },
    },
    appointmentsReload: {
      get() {
        return this.$store.state.dashboard.appointmentsReload
      },
      set(valor) {
        this.$store.commit('dashboard/setAppointmentsReload', valor)
      },
    },
    cluster: {
      get() {
        return this.$store.state.dashboard.cluster
      },
      set(valor) {
        this.$store.commit('dashboard/setClusterd', valor)
      },
    },
    markers: {
      get() {
        return this.$store.state.dashboard.markers
      },
      set(valor) {
        this.$store.commit('dashboard/setMarkers', valor)
      },
    },
    mapgoogle: {
      get() {
        return this.$store.state.dashboard.mapgoogle
      },
      set(valor) {
        this.$store.commit('dashboard/setMapgoogle', valor)
      },
    },
    infowindow: {
      get() {
        return this.$store.state.dashboard.infowindow
      },
      set(valor) {
        this.$store.commit('dashboard/setInfowindow', valor)
      },
    },
    tableItems: {
      get() {
        return this.$store.state.dashboard.tableItems
      },
      set(valor) {
        this.$store.commit('dashboard/settableItems', valor)
      },
    },
    loading: {
      get() {
        return this.$store.state.dashboard.loading
      },
      set(valor) {
        this.$store.commit('dashboard/setLoading', valor)
      },
    },
    startDate: {
      get() {
        return this.$store.state.dashboard.selectedFilter.startDate
      },
      set(valor) {
        this.$store.commit('dashboard/setStartDates', valor)
      },
    },
    endDate: {
      get() {
        return this.$store.state.dashboard.selectedFilter.endDate
      },
      set(valor) {
        this.$store.commit('dashboard/setEndDates', valor)
      },
    },
    selectedStatus: {
      get() {
        return this.$store.state.dashboard.selectedFilter.status
      },
      set(valor) {
        this.$store.commit('dashboard/setSelectedStatus', valor)
      },
    },
    selectedTypes: {
      get() {
        return this.$store.state.dashboard.selectedFilter.types
      },
      set(valor) {
        this.$store.commit('dashboard/setSelectedTypes', valor)
      },
    },
    selectedCitys: {
      get() {
        return this.$store.state.dashboard.selectedFilter.citys
      },
      set(valor) {
        this.$store.commit('dashboard/setSelectedCitys', [...valor])
      },
    },
    selectedClients: {
      get() {
        return this.$store.state.dashboard.selectedFilter.clients
      },
      set(valor) {
        this.$store.commit('dashboard/setSelectedClients', valor)
      },
    },
    selectedHosts: {
      get() {
        return this.$store.state.dashboard.selectedFilter.hosts
      },
      set(valor) {
        this.$store.commit('dashboard/setSelectedHosts', valor)
      },
    },
    selectedCountry: {
      get() {
        return this.$store.state.dashboard.selectedFilter.country
      },
      set(value) {
        this.$store.commit('dashboard/setSelectedCountry', value)
      },
    },
    dateRangeText() {
      return this.dates.join(` ${$t('dashboard.tabFilter.label.until')} `)
    },
    filteredKeys() {
      return this.keys.filter((key) => key !== 'Name')
    },
  },

  mounted() {
    Promise.resolve(localStorage.getItem('old_token'))
      .then((token) => (this.token = token))
      .then(() => this.renderMap())

    this._interval = new this.Timer(() => {
      this.updateFilter()
    }, 120000)

    this._interval.start()
  },

  beforeDestroy() {
    this.clear()
    this._interval.stop()
  },

  methods: {
    clear() {
      this.dates = []
      this.selectedStatus = []
      this.selectedTypes = []
      this.selectedCitys = []
      this.selectedClients = []
      this.selectedHosts = []
      this.selectedCountry = null
      this.search = null
    },

    updateFilter(selectedPeriod) {
      this.selectedPeriod = selectedPeriod ? selectedPeriod : this.period
      this.loading = true

      if (this.cluster) this.cluster.clearMarkers()

      this.markers = []
      this.tableItems = []

      clearInterval(this.reloadAppointment)

      this.reloadAppointment = setInterval(() => {
        this.getAppointmentsReload()
      }, 15 * 60000)

      this.selectedDates()

      const status = this.selectedStatus.map(function (element) {
        return element.value
      })
      const types = this.selectedTypes.map(function (element) {
        return element.value
      })
      const citys = this.selectedCitys.map(function (element) {
        return element.id
      })
      const hosts = this.selectedHosts.map(function (element) {
        return element.id
      })
      const client = this.selectedClients.map(function (element) {
        return element.id
      })

      this.getAppointments(
        status,
        types,
        citys,
        hosts,
        client,
        this.startDate,
        this.endDate,
        this.isFindHostMode,
        this.search,
        this.selectedCountry
      )
    },

    async getAppointmentsReload() {
      let page = 0
      let allPages = 1
      this.appointmentsReload = []

      while (page < allPages) {
        const response = await api.getAppointmentsReload(
          this.token,
          page,
          this.isFindHostMode
        )
        page = page + 1
        allPages = response.pages
        this.appointmentsReload.push(...response.result)
      }

      this.getReloadInfoPin(this.appointmentsReload)
    },

    async getAppointments(
      status,
      Types,
      Citys,
      hosts,
      client,
      startDate,
      endDate,
      isFindHostMode,
      search,
      country
    ) {
      this.appointments = []
      let page = 0
      let allPages = 1

      while (page < allPages) {
        const response = await api.getAppointments(
          this.token,
          status,
          Types,
          Citys,
          hosts,
          client,
          startDate,
          endDate,
          undefined,
          undefined,
          page,
          isFindHostMode,
          country,
          undefined,
          search
        )
        page = page + 1
        allPages = response.pages
        this.appointments.push(...response.result)
      }

      this.renderMapPin()
    },

    async getAppointmentIdTable(id) {
      const response = await api.getAppointmentId(this.token, id)
      response.date = catalogDate(response.date)
      response.status = this.$t(`status.${response.status}`)
      response.type = this.$t(`type.${response.type}`)
      this.appointmentID = response
    },

    selectedDates() {
      if (this.selectedPeriod == 0) {
        const dateStart = moment().startOf('day').format()
        this.startDate = moment.utc(dateStart).format()
        this.endDate = moment.utc(dateStart).add(1, 'd').format()
      }
      // selectedPeriod
      if (this.selectedPeriod == 1) {
        const dateStart = moment().startOf('day').format()
        this.startDate = moment.utc(dateStart).add(1, 'd').format()
        this.endDate = moment
          .utc(dateStart)
          .add(2, 'd')
          .add(3, 'hours')
          .format()
      }
      if (this.selectedPeriod == 2) {
        const dateStart = moment().startOf('day').format()
        this.startDate = moment.utc(dateStart).format()
        this.endDate = moment.utc(dateStart).add(8, 'd').format()
      }
      this.dates.push(this.startDate)
      this.dates.push(this.endDate)
    },

    renderMap() {
      this.selectedCountry = 'BR'
      this.$root.$on('selectedPeriod', (data) => data && this.updateFilter(data))
      this.updateFilter(this.selectedPeriod)
    },

    showCardTable(value) {
      this.loadingDetails = true
      this.getAppointmentIdTable(value.item.id).finally(
        () => (this.loadingDetails = false)
      )
    },

    showPinTable(id) {
      this.mapgoogle.setZoom(15)
      this.mapgoogle.setCenter(this.markers[id.id].getPosition())
      this.markers[id.id].setAnimation(this.google.maps.Animation.BOUNCE)
      setTimeout(() => {
        this.markers[id.id].setAnimation(null)
      }, 20000)
    },

    async showInfoPin(id) {
      const response = await api.getAppointmentId(this.token, id)
      this.infowindow[id].close()

      this.infowindow[id] = new this.google.maps.InfoWindow({
        content: mapPinContent(response),
        maxWidth: 520,
        minWidth: 520,
      })

      this.infowindow[id].open(this.mapgoogle, this.markers[id])
    },

    showPin(id) {
      this.mapgoogle.setZoom(14)
      this.mapgoogle.setCenter(this.markers[id].getPosition())
      this.markers[id.id].setAnimation(this.google.maps.Animation.BOUNCE)
    },

    hidePin(id) {
      this.markers[id].setAnimation(null)
    },

    async renderMapPin() {
      const promises = await this.appointments.map((element) => {
        this.createPin(element)
      })

      await Promise.all(promises).finally(() => this.loading = false)

      if (typeof this.omsmarkes === 'function') {
        this.omsmarkes.addListener('format', (marker, status) => {
          if (
            this.mapgoogle.getZoom() > 12 &&
            this.markers[marker.idAppointment]
          ) {
            let nearmarkes = this.omsmarkes.markersNearMarker(marker, false)

            let iconsvg

            if (status == 'SPIDERFIABLE') {
              this.markers[marker.idAppointment].modifyIcon = false
              iconsvg = iconSvgCluster.iconsvgcluster(nearmarkes.length)
            } else {
              this.markers[marker.idAppointment].modifyIcon = true
              iconsvg = iconSvg.iconsvg(marker.type, marker.rule)
            }

            marker.setIcon({
              url: iconsvg,
            })
          }
        })
      }
    },

    renderMapCluster() {
      if (this.cluster) {
        this.cluster.clearMarkers()
      }
      this.cluster = new MarkerClusterer(this.mapgoogle, this.markers, {
        imagePath: '/icons/map/clusters/m',
        gridSize: 40,
        maxZoom: 14,
      })
    },

    getReloadRulesColor() {
      const newRulesColor = reloadRules.reloadRulesCor(this.markers)
      for (const prop in newRulesColor) {
        this.markers[prop].rule = newRulesColor[prop].rule
        let iconsvg
        if (this.markers[prop].modifyIcon) {
          iconsvg = iconSvg.iconsvg(
            this.markers[prop].type,
            this.markers[prop].rule
          )
          this.markers[prop].setIcon({
            url: iconsvg,
          })
        }
      }
    },

    getReloadInfoPin(appointmentsUpdate) {
      const result = reloadInfoPin(
        appointmentsUpdate,
        this.markers,
        this.dates,
        this.selectedStatus,
        this.selectedTypes,
        this.selectedCitys,
        this.selectedHosts,
        this.selectedClients
      )
      if (result.create.length) {
        result.create.forEach((element) => {
          this.createPin(element)
        })
      }
      if (result.update.length) {
        result.update.forEach((element) => {
          this.updatePinInfo(element)
        })
      }
      if (result.delete.length) {
        result.delete.forEach((element) => {
          this.deletePin(element)
        })
      }
      this.getReloadRulesColor()
    },

    createPin(element) {
      setTimeout(async () => {
        this.markers[element.id] = await new this.google.maps.Marker({
          position: {
            lat: parseFloat(element.latitude_meeting),
            lng: parseFloat(element.longitude_meeting),
          },
          title: this.mountTitle(element),
          icon: {
            url: `${iconSvg.iconsvg(
              element.type,
              element.appointment_deadline_time,
              element.reschedule_count,
              element.is_urgent
            )}`,
          },
          type: element.type,
          rule: element.appointment_deadline_time,
          idAppointment: element.id,
          modifyIcon: false,
          date: element.date,
          status: element.status,
        })

        this.omsmarkes.addMarker(this.markers[element.id])

        this.infowindow[element.id] = new this.google.maps.InfoWindow({
          content: mapPinContentLoading(),
        })

        this.markers[element.id].addListener('dblclick', () => {
          this.infowindow[element.id].open(
            this.mapgoogle,
            this.markers[element.id]
          )
          this.showInfoPin(element.id)
        })

        this.tableItems.push({
          id: element.id,
          code: element.code,
          date: catalogDate(element.date),
          status: this.$t(`status.${element.status}`),
          type: this.$t(`type.${element.type}`),
          latitude_meeting: element.latitude_meeting,
          longitude_meeting: element.longitude_meeting,
        })

        this.$nextTick(() => this.renderMapCluster())
      }, 100)
    },

    mountTitle(element) {
      if (element?.reschedule_count) return `${this.$t(`type.${element.type}`)} • ${element.code} • ${element.reschedule_count} ${this.$t('dashboard.cardAppointment.numberOfReschedules')} `
      return  `${this.$t(`type.${element.type}`)} • ${element.code}`
    },

    updatePinInfo(appointment) {
      this.markers[appointment.id].date = appointment.date
      this.markers[appointment.id].status = appointment.status
      Object.keys(this.tableItems).forEach((element) => {
        if (this.tableItems[element].id == appointment.id) {
          this.tableItems[element].status = this.$t(
            `status.${appointment.status}`
          )
          this.tableItems[element].date = catalogDate(appointment.date)
        }
      })
    },

    deletePin(appointment) {
      this.omsmarkes.removeMarker(this.markers[appointment.id])
      this.markers[appointment.id].setVisible(false)
      const teste = Object.keys(this.tableItems)
      for (let index = 0; index < teste.length; index++) {
        const element = teste[index]
        if (this.tableItems[element].id == appointment.id) {
          this.tableItems.splice(element, 1)
          delete this.markers[appointment.id]
          break
        }
      }

      this.$nextTick(() => this.renderMapCluster())
    },

    Timer(fn, time) {
      let timerObj = setInterval(fn, time)

      this.stop = function () {
        if (timerObj) {
          clearInterval(timerObj)
          timerObj = null
        }

        return this
      }

      this.start = function () {
        if (!timerObj) {
          this.stop()
          timerObj = setInterval(fn, time)
        }

        return this
      }
    },
  },
}
</script>
